import { css } from "@emotion/react"
import styled from "@emotion/styled"
import type { BreakpointValues } from "@porsche-design-system/components-react"
import { breakpoint, gridGap } from "@porsche-design-system/components-react/emotion"
import { shouldForwardProp } from "src/common/shouldForwardProp"

export const Grid = styled("div", { shouldForwardProp })<{
	$columnGap?: string | BreakpointValues<string>
	$rowGap?: string
}>`
	display: grid;
	grid-template-columns: repeat(12, minmax(0, 1fr));
	${({ $columnGap }) =>
		typeof $columnGap === "object"
			? css`
	column-gap: ${$columnGap.base};
	@media (min-width: ${breakpoint.xs}px) {
		column-gap: ${$columnGap.xs};
	}
	@media (min-width: ${breakpoint.s}px) {
		column-gap: ${$columnGap.s};
	}
	@media (min-width: ${breakpoint.m}px) {
		column-gap: ${$columnGap.m};
	}
	@media (min-width: ${breakpoint.l}px) {
		column-gap: ${$columnGap.l};
	}
	@media (min-width: ${breakpoint.xl}px) {
		column-gap: ${$columnGap.xl};
	}
	@media (min-width: ${breakpoint.xxl}px) {
		column-gap: ${$columnGap.xxl};
	}`
			: css`
	column-gap: ${$columnGap ?? gridGap};
`}
	row-gap: ${({ $rowGap }) => $rowGap};
`
